export const moreHorizontalFilled = {
  name: "more-horizontal-filled" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M1.1 12C1.1 5.98 5.98 1.1 12 1.1c6.02 0 10.9 4.88 10.9 10.9 0 6.02-4.88 10.9-10.9 10.9-6.02 0-10.9-4.88-10.9-10.9Zm5.65 1.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM10.5 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm6.75 1.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z" clip-rule="evenodd"/></svg>`,
  keywords: ["more-horizontal-filled"],
  category: "utility" as const,
};
